/* src/app/@framework/components/TabContainer/tabView.component.less */
/*# sourceMappingURL=tabView.component.css.map */
